import { render, staticRenderFns } from "./ImagesUpload.vue?vue&type=template&id=66181d00"
import script from "./ImagesUpload.vue?vue&type=script&lang=js"
export * from "./ImagesUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports